(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[77103],{

/***/ 50573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.k = function FaRegImages (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 576 512"},"child":[{"tag":"path","attr":{"d":"M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"}}]})(props);
};


/***/ }),

/***/ 15787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/refactoringui/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/index.js




/***/ }),

/***/ 72603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useReservations; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9012);


function useReservations() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), data = ref[0], setData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), error = ref2[0], setError = ref2[1];
    var checkLogin = function() {
        setLoading(true);
        (0,_components_api__WEBPACK_IMPORTED_MODULE_1__/* .AuthMyReservations */ .dQ)().then(function(response) {
            if (response.data.error) {
                setError(response.data.error);
                setData([]);
            } else {
                setData(response.data);
            }
            setLoading(false);
        }).catch(function(error) {
            setError(error);
            setLoading(false);
        });
    };
    return {
        loading: loading,
        error: error,
        data: data,
        setData: setData,
        setLoading: setLoading,
        checkLogin: checkLogin
    };
};


/***/ }),

/***/ 70454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


var BackButton = function(param) {
    var isAppWebView = param.isAppWebView, _color = param.color, color = _color === void 0 ? "black" : _color, _top = param.top, top = _top === void 0 ? "top-4" : _top, _left = param.left, left = _left === void 0 ? "left-2" : _left;
    return null;
// const router = useRouter();
// if (!isAppWebView) {
//   return null;
// }
// return (
//   <button
//     onClick={() => router.back()}
//     className={`absolute ${top} ${left} sm:left-0 flex p-2 rounded-full backdrop-blur-sm transition-all text-brand-black group z-20`}
//   >
//     <Image
//       src={
//         color == "white"
//           ? "/icons/left-arrow-white.svg"
//           : "/icons/left-arrow.svg"
//       }
//       alt="Geri"
//       width={32}
//       height={32}
//     />
//   </button>
// );
};
/* harmony default export */ __webpack_exports__["Z"] = (BackButton);


/***/ }),

/***/ 16543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var DefaultCurrencyFormat = function(_param) {
    var value = _param.value, Symbol = _param.Symbol, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "value",
        "Symbol"
    ]);
    var obj = {
        "\u20BA": "TRY",
        $: "USD",
        "\u20AC": "EUR",
        "\xa3": "GBP"
    };
    var formattedValue = new Intl.NumberFormat( true ? "en-GB" : 0, {
        style: "currency",
        currency: obj[Symbol],
        minimumFractionDigits: 0
    }).format(value);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: formattedValue
    });
//return <></>;
//if (Symbol == "₺")
//  return (
//    <CurrencyFormat
//      value={value}
//      displayType={"text"}
//      thousandSeparator={"."}
//      decimalSeparator={","}
//      suffix={Symbol}
//      {...props}
//      renderText={(value) => <>{value}</>}
//    />
//  );
//return (
//  <CurrencyFormat
//    value={value}
//    displayType={"text"}
//    thousandSeparator={"."}
//    decimalSeparator={","}
//    prefix={Symbol}
//    {...props}
//    renderText={(value) => <>{value}</>}
//  />
//);
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultCurrencyFormat);


/***/ }),

/***/ 71700:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var Local = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return "".concat(src, "?quality=").concat(quality || 75);
};
/* harmony default export */ __webpack_exports__["Z"] = (Local);


/***/ }),

/***/ 71593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Blur; }
/* harmony export */ });
var Remote = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    if (width > 1920) width = 1920;
    return "".concat("https://cdn.villavillam.co.uk", "/uploads/").concat(width, "/").concat(src);
};
var Blur = function(src) {
    return "".concat("https://cdn.villavillam.co.uk", "/uploads/30/").concat(src);
};
/* harmony default export */ __webpack_exports__["Z"] = (Remote);


/***/ }),

/***/ 16719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var react_mask_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18935);








"use client";
var Input = function(_param) {
    var label = _param.label, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "label"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_2__/* .useField */ .U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    // useEffect(() => {
    //   if (field.value) helpers.setTouched(true);
    // }, [field.value]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            props.mask ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_mask_field__WEBPACK_IMPORTED_MODULE_3__/* .MaskField */ .V, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: "border-gray-300 block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary peer " + (!meta.error && field.value ? "border-green-500 focus:!border-green-500" : "") + (meta.error && field.value ? " border-red-500 focus:!border-red-500" : " ")
            }, field, props), {
                id: props.id || props.name
            })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: "border-gray-300 block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary peer " + (!meta.error && meta.touched ? "border-green-500 focus:border-green-500" : "") + (meta.error && meta.touched ? " border-red-500 focus:border-red-500" : " ")
            }, field, props), {
                id: props.id || props.name
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.name,
                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-brand-color-secondary duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-brand-color-secondary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 4600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pages_Reservations; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./auth/Reservations.js
var Reservations = __webpack_require__(72603);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Pages/Reservations/Login.module.css
var Login_module = __webpack_require__(98747);
var Login_module_default = /*#__PURE__*/__webpack_require__.n(Login_module);
// EXTERNAL MODULE: ./components/ImageLoader.js
var ImageLoader = __webpack_require__(71700);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(97762);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./validations/ReservationsLoginShema.js
var ReservationsLoginShema = __webpack_require__(88041);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
;// CONCATENATED MODULE: ./components/Pages/Reservations/ReservationLoginForm.js






var ReservationLoginForm = function(param) {
    var loginFormEmail = param.loginFormEmail, loginReservationNumber = param.loginReservationNumber, login = param.login, loginSuccess = param.loginSuccess, checkLogin = param.checkLogin;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            email: "",
            reservationNumber: ""
        },
        validationSchema: ReservationsLoginShema/* ReservationLoginShema */.m,
        onSubmit: function(values, actions) {
            (0,api/* AuthLogin */.rE)(values.email, values.reservationNumber).then(function(response) {
                if (response.data.error) {
                    localStorage.removeItem("reservations_auth");
                    react_toastify_esm/* toast.error */.Am.error(response.data.error);
                } else {
                    localStorage.setItem("reservations_auth", response.data.token);
                    react_toastify_esm/* toast.success */.Am.success(loginSuccess);
                    checkLogin();
                }
            }).catch(function(error) {
                react_toastify_esm/* toast.error */.Am.error(error.message);
            }).finally(function() {
                actions.setSubmitting(false);
            });
        },
        children: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "mb-[54px] w-full",
                onSubmit: props.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-[13px] w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                id: "email",
                                name: "email",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                onChange: props.handleChange,
                                onBlur: props.handleBlur,
                                value: props.values.email
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "email",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: loginFormEmail
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-[13px] w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "reservationNumber",
                                name: "reservationNumber",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                onChange: props.handleChange,
                                onBlur: props.handleBlur,
                                value: props.values.reservationNumber
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "reservationNumber",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: loginReservationNumber
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        disabled: props.isSubmitting || !props.isValid || !props.dirty,
                        type: "submit",
                        className: "text-white md:px-[2.75rem] px-8 md:py-[1.188rem] py-3 duration-200 bg-product-type-color hover:opacity-90 focus:ring-4 font-medium rounded-lg text-sm text-center disabled:opacity-60 disabled:cursor-not-allowed",
                        children: login
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var Reservations_ReservationLoginForm = (ReservationLoginForm);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/yup-locales/dist/yup-locales.esm.js
var yup_locales_esm = __webpack_require__(18700);
;// CONCATENATED MODULE: ./validations/MemberLoginShema.js


if (false) {} // en: Yup varsayilan (Ingilizce) mesajlari
var MemberLoginShema = es/* object */.Ry().shape({
    phone: es/* string */.Z_().required(),
    password: es/* string */.Z_().required()
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./components/Reservation/PhoneInput.js
var PhoneInput = __webpack_require__(23515);
;// CONCATENATED MODULE: ./components/Pages/Reservations/RegisterSteps/StepPhone.js










var StepPhone = function(param) {
    var onNext = param.onNext;
    var ref = (0,TranslationContext/* useTranslation */.m)(), phoneLabel = ref.phone, continueBtn = ref.continue, phoneRequired = ref.phoneRequired, phoneInvalid = ref.phoneInvalid, operationFailed = ref.operationFailed;
    var Step1Schema = es/* object */.Ry().shape({
        phoneNumber: es/* string */.Z_().required(phoneRequired).matches(/^[+0-9]+$/, phoneInvalid).min(10, phoneInvalid)
    });
    var handleStep1Submit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, actions) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,api/* Register */.aX)({
                            phoneNumber: values.phoneNumber
                        }, 1);
                    case 3:
                        response = _ctx.sent;
                        if (response.data.error) {
                            react_toastify_esm/* toast.error */.Am.error(response.data.error);
                        } else {
                            onNext(values.phoneNumber);
                        }
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        react_toastify_esm/* toast.error */.Am.error(operationFailed);
                    case 10:
                        _ctx.prev = 10;
                        actions.setSubmitting(false);
                        return _ctx.finish(10);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7,
                    10,
                    13
                ]
            ]);
        }));
        return function handleStep1Submit(values, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            phoneNumber: ""
        },
        validationSchema: Step1Schema,
        onSubmit: handleStep1Submit,
        children: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: props.handleSubmit,
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-6 w-full group h-[60px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput/* default */.Z, {
                                label: phoneLabel,
                                validname: "phoneNumberValid",
                                isrequired: "required",
                                name: "phoneNumber",
                                mode: "simple"
                            }),
                            props.errors.phoneNumber && props.touched.phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs text-red-500 mt-1",
                                children: props.errors.phoneNumber
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        disabled: props.isSubmitting || !props.isValid || !props.dirty,
                        type: "submit",
                        className: "w-full text-white px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm disabled:opacity-60",
                        children: continueBtn
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var RegisterSteps_StepPhone = (StepPhone);

;// CONCATENATED MODULE: ./components/Pages/Reservations/RegisterSteps/StepOtp.js








var StepOtp = function(param) {
    var phoneNumber = param.phoneNumber, onNext = param.onNext;
    var ref = (0,TranslationContext/* useTranslation */.m)(), otpLabel = ref.otpCode, verifyBtn = ref.verifyCode, resendBtn = ref.resendCode, otpError = ref.otpError, otpResendSuccess = ref.otpResendSuccess, otpResendError = ref.otpResendError, otpRequired = ref.otpRequired, otpLength = ref.otpLength, continueBtn = ref.continue;
    var Step2Schema = es/* object */.Ry().shape({
        otp: es/* string */.Z_().required(otpRequired).length(6, otpLength)
    });
    var handleStep2Submit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, actions) {
            var data, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        data = {
                            phoneNumber: phoneNumber,
                            otp: values.otp
                        };
                        _ctx.next = 4;
                        return (0,api/* Register */.aX)(data, 2);
                    case 4:
                        response = _ctx.sent;
                        if (response.data.error) {
                            react_toastify_esm/* toast.error */.Am.error(response.data.error);
                        } else {
                            onNext(response.data.token);
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        react_toastify_esm/* toast.error */.Am.error(otpError);
                    case 11:
                        _ctx.prev = 11;
                        actions.setSubmitting(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    11,
                    14
                ]
            ]);
        }));
        return function handleStep2Submit(values, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            otp: ""
        },
        validationSchema: Step2Schema,
        onSubmit: handleStep2Submit,
        children: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: props.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-6 w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                id: "otp",
                                name: "otp",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                onChange: props.handleChange,
                                onBlur: props.handleBlur,
                                value: props.values.otp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "otp",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: otpLabel
                            }),
                            props.errors.otp && props.touched.otp && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs text-red-500 mt-1",
                                children: props.errors.otp
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        disabled: props.isSubmitting || !props.isValid || !props.dirty,
                        type: "submit",
                        className: "w-full text-white px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm disabled:opacity-60 mb-5",
                        children: verifyBtn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var response;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.prev = 0;
                                            _ctx.next = 3;
                                            return (0,api/* Register */.aX)({
                                                phoneNumber: phoneNumber
                                            }, 4);
                                        case 3:
                                            response = _ctx.sent;
                                            if (response.data.error) {
                                                react_toastify_esm/* toast.error */.Am.error(response.data.error);
                                            } else {
                                                react_toastify_esm/* toast.success */.Am.success(otpResendSuccess);
                                            }
                                            _ctx.next = 10;
                                            break;
                                        case 7:
                                            _ctx.prev = 7;
                                            _ctx.t0 = _ctx["catch"](0);
                                            react_toastify_esm/* toast.error */.Am.error(otpResendError);
                                        case 10:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        0,
                                        7
                                    ]
                                ]);
                            })),
                            className: "text-sm font-semibold text-product-type-color hover:underline mb-5",
                            children: resendBtn
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var RegisterSteps_StepOtp = (StepOtp);

;// CONCATENATED MODULE: ./components/Pages/Reservations/RegisterSteps/StepUserInfo.js









var StepUserInfo = function(param) {
    var token = param.token, checkLogin = param.checkLogin;
    var ref = (0,TranslationContext/* useTranslation */.m)(), registrationSuccess = ref.registrationSuccess, registrationError = ref.registrationError, nameLabel = ref.name, surnameLabel = ref.surname, emailLabel = ref.email, passwordLabel = ref.password, completeRegistration = ref.completeRegistration, nameRequired = ref.nameRequired, surnameRequired = ref.surnameRequired, emailRequired = ref.emailRequired, emailInvalid = ref.emailInvalid, passwordRequired = ref.passwordRequired, passwordMin = ref.passwordMin;
    var Step3Schema = es/* object */.Ry().shape({
        name: es/* string */.Z_().required(nameRequired),
        surname: es/* string */.Z_().required(surnameRequired),
        email: es/* string */.Z_().email(emailInvalid).required(emailRequired),
        password: es/* string */.Z_().required(passwordRequired).min(6, passwordMin)
    });
    var handleStep3Submit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, actions) {
            var data, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        data = {
                            name: values.name,
                            surname: values.surname,
                            email: values.email,
                            password: values.password,
                            token: token
                        };
                        _ctx.next = 4;
                        return (0,api/* Register */.aX)(data, 3);
                    case 4:
                        response = _ctx.sent;
                        if (response.data.error) {
                            react_toastify_esm/* toast.error */.Am.error(response.data.error);
                        } else {
                            localStorage.setItem("reservations_auth", response.data.token || token);
                            react_toastify_esm/* toast.success */.Am.success(registrationSuccess);
                            checkLogin();
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        react_toastify_esm/* toast.error */.Am.error(registrationError);
                    case 11:
                        _ctx.prev = 11;
                        actions.setSubmitting(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    11,
                    14
                ]
            ]);
        }));
        return function handleStep3Submit(values, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            name: "",
            surname: "",
            email: "",
            password: ""
        },
        validationSchema: Step3Schema,
        onSubmit: handleStep3Submit,
        children: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: props.handleSubmit,
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-2 gap-4 mb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative z-0 w-full group",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        id: "name",
                                        name: "name",
                                        className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                        placeholder: " ",
                                        onChange: props.handleChange,
                                        onBlur: props.handleBlur,
                                        value: props.values.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "name",
                                        className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                        children: nameLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative z-0 w-full group",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        id: "surname",
                                        name: "surname",
                                        className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                        placeholder: " ",
                                        onChange: props.handleChange,
                                        onBlur: props.handleBlur,
                                        value: props.values.surname
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "surname",
                                        className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                        children: surnameLabel
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-4 w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "email",
                                id: "email",
                                name: "email",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                onChange: props.handleChange,
                                onBlur: props.handleBlur,
                                value: props.values.email
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "email",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: emailLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-6 w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "password",
                                id: "password",
                                name: "password",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                onChange: props.handleChange,
                                onBlur: props.handleBlur,
                                value: props.values.password
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "password",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: passwordLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        disabled: props.isSubmitting || !props.isValid || !props.dirty,
                        type: "submit",
                        className: "w-full text-white px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm disabled:opacity-60",
                        children: completeRegistration
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var RegisterSteps_StepUserInfo = (StepUserInfo);

;// CONCATENATED MODULE: ./components/Pages/Reservations/RegisterForm.js








var RegisterForm = function(param) {
    var onBackToLogin = param.onBackToLogin, checkLogin = param.checkLogin;
    var ref = (0,TranslationContext/* useTranslation */.m)(), backToLogin = ref.backToLogin, registerTitle = ref.register;
    var ref1 = (0,react.useState)(1), step = ref1[0], setStep = ref1[1]; // 1: Phone, 2: OTP, 3: Personal Info
    var ref2 = (0,react.useState)({
        phoneNumber: "",
        token: ""
    }), regData = ref2[0], setRegData = ref2[1];
    var handleStep1Next = function(phoneNumber) {
        setRegData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, regData), {
            phoneNumber: phoneNumber
        }));
        setStep(2);
    };
    var handleStep2Next = function(token) {
        setRegData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, regData), {
            token: token
        }));
        setStep(3);
    };
    var handleBackToLogin = function() {
        onBackToLogin();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    onClick: handleBackToLogin,
                    className: "text-product-type-color text-sm font-semibold flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "h-4 w-4 mr-1",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 2,
                                d: "M15 19l-7-7 7-7"
                            })
                        }),
                        backToLogin
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "font-bold text-xl mb-6 text-[#333738]",
                children: registerTitle
            }),
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterSteps_StepPhone, {
                onNext: handleStep1Next
            }),
            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterSteps_StepOtp, {
                phoneNumber: regData.phoneNumber,
                onNext: handleStep2Next
            }),
            step === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterSteps_StepUserInfo, {
                token: regData.token,
                checkLogin: checkLogin
            })
        ]
    });
};
/* harmony default export */ var Reservations_RegisterForm = (RegisterForm);

;// CONCATENATED MODULE: ./components/Pages/Reservations/ForgotSteps/ForgotStepPhone.js










var ForgotStepPhone = function(param) {
    var onNext = param.onNext;
    var ref = (0,TranslationContext/* useTranslation */.m)(), sendResetCode = ref.sendResetCode, phoneLabel = ref.phone, phoneRequired = ref.phoneRequired, operationFailed = ref.operationFailed;
    var Step1Schema = es/* object */.Ry().shape({
        phoneNumber: es/* string */.Z_().required(phoneRequired)
    });
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, actions) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,api/* Forgot */.Um)({
                            phoneNumber: values.phoneNumber
                        }, 1);
                    case 3:
                        response = _ctx.sent;
                        if (response.data.error) {
                            react_toastify_esm/* toast.error */.Am.error(response.data.error);
                        } else {
                            onNext(values.phoneNumber);
                        }
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        react_toastify_esm/* toast.error */.Am.error(operationFailed);
                    case 10:
                        _ctx.prev = 10;
                        actions.setSubmitting(false);
                        return _ctx.finish(10);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7,
                    10,
                    13
                ]
            ]);
        }));
        return function handleSubmit(values, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            phoneNumber: ""
        },
        validationSchema: Step1Schema,
        onSubmit: handleSubmit,
        children: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: props.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative z-0 mb-6 w-full group h-[60px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput/* default */.Z, {
                            label: phoneLabel,
                            validname: "phoneNumberValid",
                            isrequired: "required",
                            name: "phoneNumber",
                            mode: "simple"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        disabled: props.isSubmitting,
                        type: "submit",
                        className: "text-white w-full px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm text-center mb-5 disabled:opacity-60",
                        children: sendResetCode
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var ForgotSteps_ForgotStepPhone = (ForgotStepPhone);

;// CONCATENATED MODULE: ./components/Pages/Reservations/ForgotSteps/ForgotStepOtp.js









var ForgotStepOtp = function(param) {
    var phoneNumber = param.phoneNumber, onNext = param.onNext;
    var ref = (0,TranslationContext/* useTranslation */.m)(), otpLabel = ref.otpCode, verifyBtn = ref.verifyCode, resendBtn = ref.resendCode, otpError = ref.otpError, otpResendSuccess = ref.otpResendSuccess, otpResendError = ref.otpResendError, otpRequired = ref.otpRequired, otpLength = ref.otpLength;
    var Step2Schema = es/* object */.Ry().shape({
        otp: es/* string */.Z_().required(otpRequired).length(6, otpLength)
    });
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, actions) {
            var data, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        data = {
                            phoneNumber: phoneNumber,
                            otp: values.otp
                        };
                        _ctx.next = 4;
                        return (0,api/* Forgot */.Um)(data, 2);
                    case 4:
                        response = _ctx.sent;
                        if (response.data.error) {
                            react_toastify_esm/* toast.error */.Am.error(response.data.error);
                        } else {
                            onNext(response.data.token);
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        react_toastify_esm/* toast.error */.Am.error(otpError);
                    case 11:
                        _ctx.prev = 11;
                        actions.setSubmitting(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    11,
                    14
                ]
            ]);
        }));
        return function handleSubmit(values, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResend = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,api/* Forgot */.Um)({
                            phoneNumber: phoneNumber
                        }, 1);
                    case 3:
                        response = _ctx.sent;
                        if (response.data.error) {
                            react_toastify_esm/* toast.error */.Am.error(response.data.error);
                        } else {
                            react_toastify_esm/* toast.success */.Am.success(otpResendSuccess);
                        }
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        react_toastify_esm/* toast.error */.Am.error(otpResendError);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function handleResend() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            otp: ""
        },
        validationSchema: Step2Schema,
        onSubmit: handleSubmit,
        children: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: props.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-6 w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                id: "otp",
                                name: "otp",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                onChange: props.handleChange,
                                onBlur: props.handleBlur,
                                value: props.values.otp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "otp",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: otpLabel
                            }),
                            props.errors.otp && props.touched.otp && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs text-red-500 mt-1",
                                children: props.errors.otp
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        disabled: props.isSubmitting || !props.isValid || !props.dirty,
                        type: "submit",
                        className: "w-full text-white px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm disabled:opacity-60 mb-5",
                        children: verifyBtn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: handleResend,
                            className: "text-sm font-semibold text-product-type-color hover:underline mb-5",
                            children: resendBtn
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var ForgotSteps_ForgotStepOtp = (ForgotStepOtp);

;// CONCATENATED MODULE: ./components/Pages/Reservations/ForgotSteps/ForgotStepNewPassword.js









var ForgotStepNewPassword = function(param) {
    var token = param.token, onComplete = param.onComplete;
    var ref = (0,TranslationContext/* useTranslation */.m)(), newPasswordLabel = ref.newPassword, confirmPasswordLabel = ref.confirmPassword, updateBtn = ref.updatePassword, passwordUpdateSuccess = ref.passwordUpdateSuccess, passwordUpdateError = ref.passwordUpdateError, newPasswordRequired = ref.newPasswordRequired, confirmPasswordRequired = ref.confirmPasswordRequired, passwordMin = ref.passwordMin, passwordsNotMatch = ref.passwordsNotMatch;
    var Step3Schema = es/* object */.Ry().shape({
        password: es/* string */.Z_().required(newPasswordRequired).min(6, passwordMin),
        confirmPassword: es/* string */.Z_().oneOf([
            es/* ref */.iH("password"),
            null
        ], passwordsNotMatch).required(confirmPasswordRequired)
    });
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, actions) {
            var data, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        data = {
                            password: values.password,
                            token: token
                        };
                        _ctx.next = 4;
                        return (0,api/* Forgot */.Um)(data, 3);
                    case 4:
                        response = _ctx.sent;
                        if (response.data.error) {
                            react_toastify_esm/* toast.error */.Am.error(response.data.error);
                        } else {
                            react_toastify_esm/* toast.success */.Am.success(passwordUpdateSuccess);
                            onComplete();
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        react_toastify_esm/* toast.error */.Am.error(passwordUpdateError);
                    case 11:
                        _ctx.prev = 11;
                        actions.setSubmitting(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    11,
                    14
                ]
            ]);
        }));
        return function handleSubmit(values, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            password: "",
            confirmPassword: ""
        },
        validationSchema: Step3Schema,
        onSubmit: handleSubmit,
        children: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: props.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-6 w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "password",
                                id: "password",
                                name: "password",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                onChange: props.handleChange,
                                onBlur: props.handleBlur,
                                value: props.values.password
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "password",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: newPasswordLabel
                            }),
                            props.errors.password && props.touched.password && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs text-red-500 mt-1",
                                children: props.errors.password
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-0 mb-6 w-full group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "password",
                                id: "confirmPassword",
                                name: "confirmPassword",
                                className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                placeholder: " ",
                                onChange: props.handleChange,
                                onBlur: props.handleBlur,
                                value: props.values.confirmPassword
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "confirmPassword",
                                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                children: confirmPasswordLabel
                            }),
                            props.errors.confirmPassword && props.touched.confirmPassword && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs text-red-500 mt-1",
                                children: props.errors.confirmPassword
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        disabled: props.isSubmitting || !props.isValid || !props.dirty,
                        type: "submit",
                        className: "w-full text-white px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm disabled:opacity-60 mb-5",
                        children: updateBtn
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var ForgotSteps_ForgotStepNewPassword = (ForgotStepNewPassword);

;// CONCATENATED MODULE: ./components/Pages/Reservations/ForgotForm.js








var ForgotForm = function(param) {
    var onBackToLogin = param.onBackToLogin;
    var ref = (0,TranslationContext/* useTranslation */.m)(), backToLogin = ref.backToLogin, createNewPassword = ref.createNewPassword, forgotPassword = ref.forgotPassword;
    var ref1 = (0,react.useState)(1), step = ref1[0], setStep = ref1[1];
    var ref2 = (0,react.useState)({
        phoneNumber: "",
        token: ""
    }), data = ref2[0], setData = ref2[1];
    var handleStep1Next = function(phoneNumber) {
        setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            phoneNumber: phoneNumber
        }));
        setStep(2);
    };
    var handleStep2Next = function(token) {
        setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            token: token
        }));
        setStep(3);
    };
    var handleComplete = function() {
        onBackToLogin();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    onClick: onBackToLogin,
                    className: "text-product-type-color text-sm font-semibold flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "h-4 w-4 mr-1",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 2,
                                d: "M15 19l-7-7 7-7"
                            })
                        }),
                        backToLogin
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "font-bold text-xl mb-6 text-[#333738]",
                children: step === 3 ? createNewPassword : forgotPassword
            }),
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotSteps_ForgotStepPhone, {
                onNext: handleStep1Next
            }),
            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotSteps_ForgotStepOtp, {
                phoneNumber: data.phoneNumber,
                onNext: handleStep2Next
            }),
            step === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotSteps_ForgotStepNewPassword, {
                token: data.token,
                onComplete: handleComplete
            })
        ]
    });
};
/* harmony default export */ var Reservations_ForgotForm = (ForgotForm);

;// CONCATENATED MODULE: ./components/Pages/Reservations/MemberLoginForm.js












var MemberLoginForm = function(param) {
    var checkLogin = param.checkLogin;
    var ref = (0,TranslationContext/* useTranslation */.m)(), loginSuccessText = ref.loginSuccess, loginError = ref.loginError, passwordLabel = ref.password, loginBtn = ref.login, forgotPasswordBtn = ref.forgotPassword, noAccountText = ref.noAccount, registerBtn = ref.register, phoneLabel = ref.phone;
    var ref1 = (0,react.useState)("login"), mode = ref1[0], setMode = ref1[1]; // "login", "register" or "forgot-password"
    if (mode === "register") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_RegisterForm, {
            onBackToLogin: function() {
                return setMode("login");
            },
            checkLogin: checkLogin
        });
    }
    if (mode === "forgot-password") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_ForgotForm, {
            onBackToLogin: function() {
                return setMode("login");
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: {
                    phone: "",
                    password: ""
                },
                validationSchema: MemberLoginShema,
                onSubmit: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, actions) {
                        var data, response;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.prev = 0;
                                    data = {
                                        userName: values.phone,
                                        password: values.password
                                    };
                                    _ctx.next = 4;
                                    return (0,api/* Login */.m3)(data);
                                case 4:
                                    response = _ctx.sent;
                                    if (response.data.error) {
                                        localStorage.removeItem("reservations_auth");
                                        react_toastify_esm/* toast.error */.Am.error(response.data.error);
                                    } else {
                                        localStorage.setItem("reservations_auth", response.data.token);
                                        react_toastify_esm/* toast.success */.Am.success(loginSuccessText);
                                        checkLogin();
                                    }
                                    _ctx.next = 12;
                                    break;
                                case 8:
                                    _ctx.prev = 8;
                                    _ctx.t0 = _ctx["catch"](0);
                                    console.error("Member Login error:", _ctx.t0);
                                    react_toastify_esm/* toast.error */.Am.error(loginError);
                                case 12:
                                    _ctx.prev = 12;
                                    actions.setSubmitting(false);
                                    return _ctx.finish(12);
                                case 15:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                8,
                                12,
                                15
                            ]
                        ]);
                    }));
                    return function(values, actions) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "mb-6 w-full",
                        onSubmit: props.handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative z-0 mb-[13px] w-full group h-[60px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput/* default */.Z, {
                                    label: phoneLabel,
                                    validname: "phoneValid",
                                    isrequired: "required",
                                    name: "phone",
                                    mode: "simple"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative z-0 mb-[13px] w-full group",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "password",
                                        id: "password",
                                        name: "password",
                                        className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                        placeholder: " ",
                                        onChange: props.handleChange,
                                        onBlur: props.handleBlur,
                                        value: props.values.password
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "password",
                                        className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                        children: passwordLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                disabled: props.isSubmitting || !props.isValid || !props.dirty,
                                type: "submit",
                                className: "text-white w-full px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm text-center disabled:opacity-60 disabled:cursor-not-allowed mb-4",
                                children: loginBtn
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-end mb-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return setMode("forgot-password");
                                    },
                                    className: "text-xs text-[#A2B2B8] hover:text-product-type-color transition-colors",
                                    children: forgotPasswordBtn
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center items-center w-full mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm text-[#A2B2B8] mr-2",
                        children: noAccountText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return setMode("register");
                        },
                        className: "text-sm font-bold text-product-type-color hover:underline",
                        children: registerBtn
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Reservations_MemberLoginForm = (MemberLoginForm);

;// CONCATENATED MODULE: ./components/Pages/Reservations/Login.js










var Login = function(param) {
    var checkLogin = param.checkLogin, ssr = param.ssr;
    var ref = (0,react.useState)("reservation"), activeTab = ref[0], setActiveTab = ref[1]; // "reservation" or "member"
    var ContactPage = ssr.result.ContactPage;
    var ref1 = (0,TranslationContext/* useTranslation */.m)(), loginRightDescription = ref1.loginRightDescription, loginRightDescriptionContactLink = ref1.loginRightDescriptionContactLink, loginLeftSubtitle = ref1.loginLeftSubtitle, loginLeftTitle = ref1.loginLeftTitle, loginLeftCopyRight = ref1.loginLeftCopyRight, welcome = ref1.welcome, loginSuccess = ref1.loginSuccess, loginFormEmail = ref1.loginFormEmail, loginReservationNumber = ref1.loginReservationNumber, login = ref1.login, loginRightDescriptionBottom = ref1.loginRightDescriptionBottom, rezervationCode = ref1.rezervationCode, memberLogin = ref1.memberLogin;
    var ContactLink = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: ContactPage.url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "text-information-color2 border-b border-information-color2",
                children: loginRightDescriptionContactLink
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-wrap lg:h-full bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:w-[52.5%] w-full xl:mb-0 mb-5 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full h-64 lg:h-full relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/villas-wealper.jpg",
                                loader: ImageLoader/* default */.Z,
                                layout: "fill",
                                className: "object-cover w-full h-full",
                                alt: "Rezervasyonlar\u0131m"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-1/3 ".concat((Login_module_default()).leftSpace),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-semibold text-[22px] lg:leading-8 text-white",
                                            children: loginLeftSubtitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold md:text-[40px] text-[35px] lg:leading-[55px] text-white",
                                            children: loginLeftTitle
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-0 mb-9 ".concat((Login_module_default()).leftSpace),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold text-[12px] leading-4 text-white",
                                    children: loginLeftCopyRight
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:w-[47.5%] w-full h-full lg:pl-20 pl-3 lg:pb-0 pb-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "xl:w-[500px] xl:pr-0 pr-3 h-full flex flex-col items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col mb-10 w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold text-[14px] leading-[19px] text-information-color2",
                                        children: loginLeftTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold text-[#333738] text-[30px] leading-10 mb-[14px]",
                                        children: welcome
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-medium text-13 leading-6 text-[#A2B2B8] mb-6",
                                        dangerouslySetInnerHTML: {
                                            __html: loginRightDescription.replace("{contact}", (0,server_browser/* renderToString */.Dq)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ContactLink, {})))
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex border-b border-[#dee9ed] mb-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return setActiveTab("reservation");
                                                },
                                                className: "pb-4 px-4 text-sm font-bold transition-all ".concat(activeTab === "reservation" ? "text-product-type-color border-b-2 border-product-type-color" : "text-[#A2B2B8] hover:text-[#333738]"),
                                                children: rezervationCode
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return setActiveTab("member");
                                                },
                                                className: "pb-4 px-4 text-sm font-bold transition-all ".concat(activeTab === "member" ? "text-product-type-color border-b-2 border-product-type-color" : "text-[#A2B2B8] hover:text-[#333738]"),
                                                children: memberLogin
                                            })
                                        ]
                                    })
                                ]
                            }),
                            activeTab === "reservation" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_ReservationLoginForm, {
                                loginFormEmail: loginFormEmail,
                                loginReservationNumber: loginReservationNumber,
                                login: login,
                                loginSuccess: loginSuccess,
                                checkLogin: checkLogin
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_MemberLoginForm, {
                                checkLogin: checkLogin
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-[#fcf4f4] border border-[#f2dcdc] rounded p-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-medium text-13 leading-6 text-[#d20000]",
                                    children: loginRightDescriptionBottom
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Reservations_Login = (Login);

// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
// EXTERNAL MODULE: ./components/DefaultCurrencyFormat.js
var DefaultCurrencyFormat = __webpack_require__(16543);
// EXTERNAL MODULE: ./components/LoaderRemote.js
var LoaderRemote = __webpack_require__(71593);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 16 modules
var dialog = __webpack_require__(39627);
;// CONCATENATED MODULE: ./components/Reservations/Step.js



var Step = function(param) {
    var children = param.children, _status = param.status, status = _status === void 0 ? 0 : _status;
    var colors = {
        0: "text-[#B2C2CB]",
        1: "text-[#4BAE4F]",
        2: "text-brand-color-primary"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col justify-center items-center gap-y-[10px] flex-[0_0_10%]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: colors[status],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                    name: "guestconfirmation"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-[14px] font-semibold leading-5 " + colors[status],
                children: children
            })
        ]
    });
};
/* harmony default export */ var Reservations_Step = (Step);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./validations/InvoiceSheme.js


if (false) {} // en: Yup varsayilan (Ingilizce) mesajlari
var InvoiceSheme = es/* object */.Ry().shape({
    faturatipi: es/* number */.Rx().required(),
    isim: es/* string */.Z_().required(),
    tcno: es/* number */.Rx().required(),
    email: es/* string */.Z_().required().email(),
    telefonIsValid: es/* boolean */.O7().isTrue()
});

;// CONCATENATED MODULE: ./validations/PassengerShema.js


if (false) {} // en: Yup varsayilan (Ingilizce) mesajlari
var PassengerShema = es/* object */.Ry().shape({
    name: es/* string */.Z_().required(),
    gender: es/* boolean */.O7().required(),
    day: es/* string */.Z_().matches(/0[1-9]|1[0-9]|2[0-9]|3[0-1]/).required(),
    month: es/* string */.Z_().matches(/0[1-9]|1[0-2]/).required(),
    year: es/* string */.Z_().matches(/^\d{4}$/).required(),
    placeOfBirth: es/* string */.Z_().required(),
    tc: es/* string */.Z_().required(),
    isTurkish: es/* boolean */.O7()
});

// EXTERNAL MODULE: ./components/Pages/Payment/Input.js
var Input = __webpack_require__(16719);
;// CONCATENATED MODULE: ./components/Pages/Reservations/GuestInformationSuccessfully.js




var GuestInformationSuccessfully = function(param) {
    var setOpen = param.setOpen;
    var ref = (0,TranslationContext/* useTranslation */.m)(), GuestInformationSuccessfullyTitle = ref.GuestInformationSuccessfullyTitle, GuestInformationSuccessfullyDescription = ref.GuestInformationSuccessfullyDescription, close = ref.close;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " flex flex-col items-center justify-center h-full mb-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center items-center text-center md:w-[571px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[#4BAE4F] mb-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                        name: "guestconfirmation",
                        size: 60
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-dark text-[23px] font-semibold",
                    children: GuestInformationSuccessfullyTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-[#637176] text-13 font-medium mb-10",
                    children: GuestInformationSuccessfullyDescription
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: function() {
                        return setOpen(false);
                    },
                    className: "py-[10px] px-[17px] rounded bg-red-400 hover:bg-red-800 duration-200 text-white text-sm font-bold",
                    children: close
                })
            ]
        })
    });
};
/* harmony default export */ var Reservations_GuestInformationSuccessfully = (GuestInformationSuccessfully);

;// CONCATENATED MODULE: ./components/Pages/Reservations/GuestInformation.js











var GuestInformation = function(param) {
    var activeTabs = param.activeTabs, page = param.page, setPage = param.setPage, formData = param.formData, setFormData = param.setFormData, validTabs = param.validTabs, setValidTabs = param.setValidTabs, passenger = param.passenger, step = param.step, setStep = param.setStep, passengerInformationData = param.passengerInformationData, loginData = param.loginData, id = param.id, setOpen = param.setOpen, list = param.list, dateDay = param.dateDay, dateMonth = param.dateMonth, dateYear = param.dateYear;
    var handleSubmit = function(data) {
        setStep(1);
    };
    var Save = function(passengerData, actions) {
        (0,api/* SavePassengerInformation */.li)(loginData.Token, id, {
            invoice: passengerData,
            passenger: formData
        }).then(function(e) {
            if (e.data.error) {
                react_toastify_esm/* toast.error */.Am.error(e.data.error);
            } else {
                react_toastify_esm/* toast.success */.Am.success(e.data.success);
                setStep(2);
                list();
            }
        }).finally(function(e) {
            actions.setSubmitting(false);
        });
    };
    var ref = (0,TranslationContext/* useTranslation */.m)(), GuestInformationTitle = ref.GuestInformationTitle, GuestInformationName = ref.GuestInformationName, GuestInformationGender = ref.GuestInformationGender, GuestInformationGenderMale = ref.GuestInformationGenderMale, GuestInformationGenderFemale = ref.GuestInformationGenderFemale, GuestInformationBirthDate = ref.GuestInformationBirthDate, GuestInformationBirthPlace = ref.GuestInformationBirthPlace, GuestInformationTc = ref.GuestInformationTc, GuestInformationNotTurkeyPeople = ref.GuestInformationNotTurkeyPeople, goBack = ref.goBack, save = ref.save, GuestInformationPassaport = ref.GuestInformationPassaport, GuestInformationInvoiceType = ref.GuestInformationInvoiceType, GuestInformationInvoiceTypeOption1 = ref.GuestInformationInvoiceTypeOption1, GuestInformationInvoiceTypeOption2 = ref.GuestInformationInvoiceTypeOption2, GuestInformationInvoiceTypeOption1Name = ref.GuestInformationInvoiceTypeOption1Name, GuestInformationInvoiceTypeOption2Name = ref.GuestInformationInvoiceTypeOption2Name, GuestInformationInvoiceTaxOffice = ref.GuestInformationInvoiceTaxOffice, GuestInformationInvoiceTaxNumber = ref.GuestInformationInvoiceTaxNumber, address = ref.address, email = ref.email, phone = ref.phone;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-[54px] w-full",
            children: [
                step == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex xmd:flex-nowrap flex-wrap xmd:gap-x-6 gap-y-10",
                    children: activeTabs.map(function(i, k) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                            initialValues: {
                                name: "",
                                gender: "",
                                day: "",
                                month: "",
                                year: "",
                                placeOfBirth: "",
                                tc: "",
                                isTurkish: false
                            },
                            validationSchema: PassengerShema,
                            onSubmit: function(values, actions) {
                                var old = (0,_to_consumable_array/* default */.Z)(formData);
                                if (old[i]) {
                                    old[i] = values;
                                    setFormData(old);
                                } else setFormData((0,_to_consumable_array/* default */.Z)(formData).concat([
                                    values
                                ]));
                                setValidTabs((0,_to_consumable_array/* default */.Z)(validTabs).concat([
                                    i
                                ]));
                                actions.setSubmitting(false);
                                if (page != passenger) {
                                    actions.resetForm();
                                    setPage(page + 1);
                                } else {
                                    handleSubmit(formData);
                                }
                                if (formData[i + 1]) actions.setValues(formData[i + 1]);
                            },
                            children: function(props) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    className: "flex flex-col w-full",
                                    onSubmit: props.handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-semibold xmd:text-[23px] text-[17px] leading-8 text-dark mb-6",
                                            children: GuestInformationTitle.replace("{no}", i + 1)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 mb-[30px] w-full group",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "name",
                                                placeholder: " ",
                                                label: GuestInformationName
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center mb-7",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-[#A2B2B8] text-13 font-medium leading-4 mr-[66px]",
                                                    children: GuestInformationGender
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center mr-6 justify-center content-center gap-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "text-13 font-medium text-gray-900 flex items-center gap-x-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                    type: "radio",
                                                                    name: "gender",
                                                                    value: "0"
                                                                }),
                                                                GuestInformationGenderFemale
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "text-13 font-medium text-gray-900 flex items-center gap-x-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                    type: "radio",
                                                                    name: "gender",
                                                                    value: "1"
                                                                }),
                                                                GuestInformationGenderMale
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex ml:flex-nowrap flex-wrap items-center mb-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-[#A2B2B8] text-13 font-medium leading-4 mr-9 whitespace-nowrap ml:mb-0 mb-2",
                                                    children: GuestInformationBirthDate
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-x-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "relative z-0 xl:w-[145px] w-full group ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                name: "day",
                                                                placeholder: "- -",
                                                                label: dateDay,
                                                                mask: "__",
                                                                replacement: {
                                                                    _: /\d/
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "relative z-0 xl:w-[145px] w-full group",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                name: "month",
                                                                placeholder: "- -",
                                                                label: dateMonth,
                                                                mask: "__",
                                                                replacement: {
                                                                    _: /\d/
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "relative z-0 xl:w-[145px] w-full group",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                name: "year",
                                                                placeholder: "- - - -",
                                                                label: dateYear,
                                                                mask: "____",
                                                                replacement: {
                                                                    _: /\d/
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 mb-2 w-full group",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "placeOfBirth",
                                                placeholder: " ",
                                                label: GuestInformationBirthPlace
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 mb-2 w-full ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "tc",
                                                placeholder: " ",
                                                label: props.values.isTurkish ? GuestInformationPassaport : GuestInformationTc
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: "text-13 font-medium text-gray-900 flex items-center gap-x-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    type: "checkbox",
                                                    name: "isTurkish"
                                                }),
                                                GuestInformationNotTurkeyPeople
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-end gap-x-2 ",
                                            children: [
                                                page > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    onClick: function() {
                                                        setPage(page - 1);
                                                        props.setValues(formData[i - 1]);
                                                    },
                                                    className: "py-[10px] px-[17px] rounded border border-[#b2c2cb] text-[#B2C2CB] text-[12px] font-bold",
                                                    children: goBack
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "submit",
                                                    disabled: props.isSubmitting || !props.isValid || !props.dirty,
                                                    className: "py-[10px] px-[17px] rounded border bg-primary text-white text-sm font-bold disabled:opacity-60 disabled:cursor-not-allowed",
                                                    children: save
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        }, k);
                    })
                }),
                step == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex xmd:flex-nowrap flex-wrap xmd:gap-x-6 gap-y-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                            initialValues: {
                                faturatipi: "1",
                                isim: passengerInformationData.reservation.musteri,
                                tcno: passengerInformationData.reservation.tc,
                                email: passengerInformationData.reservation.email,
                                telefon: passengerInformationData.reservation.telefon,
                                mesaj: "",
                                vergidairesi: "",
                                telefonIsValid: false
                            },
                            validationSchema: InvoiceSheme,
                            onSubmit: function(values, actions) {
                                Save(values, actions);
                            },
                            children: function(props) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    className: "flex flex-wrap w-full",
                                    onSubmit: props.handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center mb-7 mt-4 w-full p-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-[#A2B2B8] text-13 font-medium leading-4 mr-[66px]",
                                                    children: GuestInformationInvoiceType
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center mr-6 justify-center content-center gap-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "text-13 font-medium text-gray-900 flex items-center gap-x-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                    type: "radio",
                                                                    name: "faturatipi",
                                                                    value: "1"
                                                                }),
                                                                GuestInformationInvoiceTypeOption1
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "text-13 font-medium text-gray-900 flex items-center gap-x-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                    type: "radio",
                                                                    name: "faturatipi",
                                                                    value: "2"
                                                                }),
                                                                GuestInformationInvoiceTypeOption2
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 w-full sm:w-1/2 group p-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "isim",
                                                placeholder: " ",
                                                label: props.values.faturatipi == "1" ? GuestInformationInvoiceTypeOption1Name : GuestInformationInvoiceTypeOption2Name
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 w-full sm:w-1/2 group p-1 " + (props.values.faturatipi == "1" ? "hidden" : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "vergidairesi",
                                                placeholder: " ",
                                                label: GuestInformationInvoiceTaxOffice
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 w-full sm:w-1/2 group p-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "tcno",
                                                placeholder: " ",
                                                label: props.values.faturatipi == "1" ? GuestInformationTc : GuestInformationInvoiceTaxNumber
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 w-full sm:w-1/2 group p-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "email",
                                                placeholder: " ",
                                                label: email
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 w-full sm:w-1/2 group min-h-[70px] p-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput/* default */.Z, {
                                                name: "telefon",
                                                validname: "telefonIsValid",
                                                label: phone,
                                                mode: "simple",
                                                isrequired: "required"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-0 w-full sm:w-1/2 group p-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                name: "adres",
                                                placeholder: " ",
                                                label: address
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center justify-end gap-x-2 w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "submit",
                                                disabled: props.isSubmitting || !props.isValid || !props.dirty,
                                                className: "py-[10px] px-[17px] rounded border bg-primary text-white text-sm font-bold disabled:opacity-60 disabled:cursor-not-allowed",
                                                children: save
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    })
                }),
                step == 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_GuestInformationSuccessfully, {
                    setOpen: setOpen
                })
            ]
        })
    });
};
/* harmony default export */ var Reservations_GuestInformation = (GuestInformation);

;// CONCATENATED MODULE: ./components/Pages/Reservations/ReservationGuestInformation.js






var ReservationGuestInformation = function(param) {
    var setOpen = param.setOpen, passengerInformationData = param.passengerInformationData, loginData = param.loginData, rez = param.rez, list = param.list;
    var ref = (0,TranslationContext/* useTranslation */.m)(), customer = ref.customer, reservationGuestInformationTitle = ref.reservationGuestInformationTitle, reservationGuestInformationTitleName1 = ref.reservationGuestInformationTitleName1, reservationGuestInformationTitleName2 = ref.reservationGuestInformationTitleName2, reservationGuestInformationSubTitle = ref.reservationGuestInformationSubTitle, close = ref.close;
    var ref1 = (0,react.useState)([]), activeTabs = ref1[0], setActiveTabs = ref1[1];
    var ref2 = (0,react.useState)([]), formData = ref2[0], setFormData = ref2[1];
    var ref3 = (0,react.useState)(1), page = ref3[0], setPage = ref3[1];
    var ref4 = (0,react.useState)([]), validTabs = ref4[0], setValidTabs = ref4[1];
    var ref5 = (0,react.useState)(0), step = ref5[0], setStep = ref5[1];
    var ref6 = (0,react.useState)([]), tabList = ref6[0], setTabList = ref6[1];
    (0,react.useEffect)(function() {
        var CustomerTitle = [];
        for(var index = 0; index < passengerInformationData.reservation.totalPassenger; index++){
            CustomerTitle.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Reservations_Step, {
                status: activeTabs.includes(index) ? 2 : validTabs.includes(index) ? 1 : 0,
                children: [
                    customer,
                    " ",
                    index + 1
                ]
            }, index));
        }
        setTabList(CustomerTitle);
    }, [
        activeTabs
    ]);
    (0,react.useEffect)(function() {
        setActiveTabs([
            page - 1
        ]);
    }, [
        page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            step != "2" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex sm:flex-nowrap flex-wrap items-start justify-between last:mr-auto first:ml:",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col sm:order-1 order-2 flex-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "xmd:text-[23px] text-[17px] text-dark font-semibold leading-8 mb-[10px]",
                                    dangerouslySetInnerHTML: {
                                        __html: reservationGuestInformationTitle.replace("{reservationId}", passengerInformationData.reservation.id).replace("{name}", step == 0 ? reservationGuestInformationTitleName1 : reservationGuestInformationTitleName2)
                                    }
                                }),
                                step == 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center mb-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-[#C11046]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                                                name: "problemreport"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-13 font-semibold leading-4 ml-[6px] text-dark",
                                            dangerouslySetInnerHTML: {
                                                __html: reservationGuestInformationSubTitle.replace("{count}", passengerInformationData.reservation.totalPassenger)
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            onClick: function() {
                                return setOpen(false);
                            },
                            className: "bg-transparent shadow-none flex items-center sm:order-2 order-1 sm:ml-0 ml-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                                    name: "close"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-dark text-13 font-semibold leading-4 ml-3",
                                    children: close
                                })
                            ]
                        })
                    ]
                })
            }),
            step == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center min-h-0 whitespace-nowrap overflow-x-auto w-full mb-[50px]",
                children: tabList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_GuestInformation, {
                    activeTabs: activeTabs,
                    page: page,
                    setPage: setPage,
                    formData: formData,
                    setFormData: setFormData,
                    validTabs: validTabs,
                    setValidTabs: setValidTabs,
                    step: step,
                    setStep: setStep,
                    passengerInformationData: passengerInformationData,
                    passenger: passengerInformationData.reservation.totalPassenger,
                    loginData: loginData,
                    id: rez.hashed,
                    setOpen: setOpen,
                    list: list
                })
            })
        ]
    });
};
/* harmony default export */ var Reservations_ReservationGuestInformation = (ReservationGuestInformation);

;// CONCATENATED MODULE: ./components/Pages/Reservations/CustomerInformationArea.js






var CustomerInformationArea = function(param) {
    var passengerInformationData = param.passengerInformationData;
    var ref = (0,TranslationContext/* useTranslation */.m)(), reservationNo = ref.reservationNo, reservationDate = ref.reservationDate, ReservationStatus3Text = ref.ReservationStatus3Text, reservationCustomerName = ref.reservationCustomerName, reservationDate1 = ref.reservationDate1, reservationDate2 = ref.reservationDate2, reservationtionPrice = ref.reservationtionPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ct:w-[380px] w-full 2xl:pr-14 xl:pr-6 xl:border-r-2 border-[#EDF6FB] xl:order-1 order-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative xl:w-[264px] w-full h-[173px] rounded mb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: passengerInformationData.reservation.resim,
                    layout: "fill",
                    loader: LoaderRemote/* default */.Z,
                    alt: passengerInformationData.reservation.title,
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-start mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mr-9",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-semibold text-13 leading-[18px] text-dark ",
                                children: [
                                    reservationNo,
                                    " :"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-semibold text-13 leading-[18px] text-dark border-b",
                                children: passengerInformationData.reservation.id
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "font-semibold text-13 text-[#A1B2B8] leading-[18px]",
                        children: [
                            reservationDate,
                            " :",
                            " ",
                            passengerInformationData.reservation.islem_tarihi
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center xl:justify-start justify-between mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[23px] font-semibold text-dark leading-[31px] mr-3",
                        children: passengerInformationData.reservation.baslik
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center py-[6px] px-[10px] rounded bg-[#00BBC0] mr-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-bold text-[10px] leading-[14px] text-white",
                            children: ReservationStatus3Text
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-end justify-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mr-[10px] mb-[5px]",
                                    children: reservationCustomerName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark",
                                    children: passengerInformationData.reservation.musteri
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mr-[10px] mb-[5px]",
                                    children: reservationDate1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark",
                                    children: passengerInformationData.reservation.tarih
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mr-[10px] mb-[5px]",
                                    children: reservationDate2
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark",
                                    children: passengerInformationData.reservation.tarih2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mr-[10px] mb-[5px]",
                                    children: reservationtionPrice
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                        value: passengerInformationData.reservation.tutar,
                                        Symbol: passengerInformationData.reservation.Symbol
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Reservations_CustomerInformationArea = (CustomerInformationArea);

// EXTERNAL MODULE: ./components/Loaders/ReservationsLoading.js
var ReservationsLoading = __webpack_require__(36289);
;// CONCATENATED MODULE: ./components/Pages/Reservations/GuestModals.js








var GuestModals = function(param) {
    var data = param.data, guestModal = param.guestModal, setGuestModal = param.setGuestModal, setguestLoading = param.setguestLoading, open = param.open, setOpen = param.setOpen, rez = param.rez, list = param.list;
    var ref = (0,react.useState)(false), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), passengerInformationData = ref2[0], setPassengerInformationData = ref2[1];
    var cancelButtonRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (guestModal) {
            setError(false);
            setLoading(true);
            (0,api/* GetPassengerInformation */.dP)(data.Token, guestModal).then(function(result) {
                if (result.data.error) {
                    setError(result.data.error);
                    setGuestModal(false);
                } else {
                    setOpen(guestModal ? true : false);
                    setError(false);
                    setPassengerInformationData(result.data);
                }
            }).finally(function(e) {
                setLoading(false);
            });
        }
    }, [
        guestModal
    ]);
    (0,react.useEffect)(function() {
        setguestLoading(loading);
    }, [
        loading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: open,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-50",
            initialFocus: cancelButtonRef,
            onClose: setOpen,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "scale-0",
                    enterTo: "scale-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-black bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto mx-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex min-h-full items-center justify-center text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Panel */.V.Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all overflow-y-auto max-h-[calc(100vh-160px)] sm:my-8 sm:w-full sm:max-w-fit ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex xl:flex-nowrap flex-wrap bg-white rounded-[30px] 2xl:py-14 py-5 2xl:px-14 px-5",
                                    children: error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto",
                                        children: error
                                    }) : loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservationsLoading/* default */.Z, {})
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_CustomerInformationArea, {
                                                passengerInformationData: passengerInformationData
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " w-full xl:pl-[42px] xl:order-2 order-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_ReservationGuestInformation, {
                                                    setOpen: setOpen,
                                                    loginData: data,
                                                    passengerInformationData: passengerInformationData,
                                                    rez: rez,
                                                    list: list
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Reservations_GuestModals = (GuestModals);

// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaRegImages.js
var FaRegImages = __webpack_require__(50573);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/Pages/Reservations/ReservationItem.js













var Fancybox = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 99965).then(__webpack_require__.bind(__webpack_require__, 92235));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92235)
            ];
        }
    }
});
var ReservationItem = function(param) {
    var data = param.data, ssr = param.ssr, auth = param.auth, datax = param.datax, list = param.list;
    var ref, ref1, ref2;
    var ref3 = (0,TranslationContext/* useTranslation */.m)(), ReservationStatus0 = ref3.ReservationStatus0, ReservationStatus1 = ref3.ReservationStatus1, ReservationStatus1ActionBtn = ref3.ReservationStatus1ActionBtn, ReservationStatus1ActionCompleted = ref3.ReservationStatus1ActionCompleted, ReservationStatus1ActionBtn2 = ref3.ReservationStatus1ActionBtn2, ReservationStatus3 = ref3.ReservationStatus3, ReservationStatus3Text = ref3.ReservationStatus3Text, ReservationStatus3ActionBtn = ref3.ReservationStatus3ActionBtn, ReservationStatus3ActionBtn2 = ref3.ReservationStatus3ActionBtn2, ReservationStatus3ActionBtn2Completed = ref3.ReservationStatus3ActionBtn2Completed, ReservationStatus4 = ref3.ReservationStatus4, reservationNo = ref3.reservationNo, reservationDate = ref3.reservationDate, reservationCustomerName = ref3.reservationCustomerName, reservationDate1 = ref3.reservationDate1, reservationDate2 = ref3.reservationDate2, reservationtionPrice = ref3.reservationtionPrice, paymentMethod1Title = ref3.paymentMethod1Title, paymentMethod2Title = ref3.paymentMethod2Title, person = ref3.person, bedRoom = ref3.bedRoom, bathRoom = ref3.bathRoom;
    var ref4 = (0,react.useState)(false), guestModal = ref4[0], setGuestModal = ref4[1];
    var ref5 = (0,react.useState)(true), guestLoading = ref5[0], setguestLoading = ref5[1];
    var ref6 = (0,react.useState)(false), open = ref6[0], setOpen = ref6[1];
    var PhotosWithoutCover = data === null || data === void 0 ? void 0 : data.photos;
    var ReservationStatus = {
        0: {
            text: ReservationStatus0,
            statusBtn: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center py-[6px] px-[10px] rounded bg-slate-300",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                        name: "wheltime"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold text-[10px] leading-[14px] ml-[10px] text-white",
                        children: ReservationStatus0
                    })
                ]
            })
        },
        1: {
            text: ReservationStatus1,
            statusBtn: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center py-[6px] px-[10px] rounded bg-[#FC833F]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                        name: "wheltime"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold text-[10px] leading-[14px] ml-[10px] text-white",
                        children: ReservationStatus1
                    })
                ]
            }),
            actionBtnTop: data.odeme == 2 ?  false ? 0 : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/".concat(ssr.result.BankTransferPage.url, "?_=").concat(data.hashed),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "text-white px-[17px] mb-2 xl:mb-0 xl:mr-1 mr-0 xl:w-auto w-full py-[10px] duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm text-center ",
                        children: paymentMethod1Title
                    })
                })
            }) : "",
            actionBtn: data.odeme == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/".concat(ssr.result.PaymentPage.url, "?_=").concat(data.hashed),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "text-white px-[17px] mb-2 xl:mb-0 xl:mr-1 mr-0 xl:w-auto w-full py-[10px] duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm text-center ",
                        children: paymentMethod2Title
                    })
                })
            }) : ""
        },
        3: {
            text: ReservationStatus3,
            statusBtn: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center py-[6px] px-[10px] rounded bg-green-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-bold text-[10px] leading-[14px] text-white",
                    children: ReservationStatus3Text
                })
            }),
            actionBtnTop: data.odeme == 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "flex items-center text-[#0176AB] xl:ml-0 ml-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                        name: "problemreport"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[12px] font-bold leading-4 ml-4 border-b border-[#0176ab]",
                        children: ReservationStatus3ActionBtn
                    })
                ]
            }) : "",
            actionBtn: data.ToplamKisiBilgisi == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    setGuestModal(data.hashed);
                    setOpen(true);
                },
                disabled: guestLoading,
                className: "text-white xl:w-auto w-full px-[17px] py-[10px] duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] rounded text-[12px] font-bold ",
                children: ReservationStatus3ActionBtn2
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-white xl:w-auto w-full px-[17px] py-[10px] duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] rounded text-[12px] font-bold",
                children: ReservationStatus3ActionBtn2Completed
            })
        },
        4: {
            text: {
                ReservationStatus4: ReservationStatus4
            },
            statusBtn: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center py-[6px] px-[10px] rounded bg-red-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-bold text-[10px] leading-[14px] text-white",
                    children: ReservationStatus4
                })
            })
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center flex-wrap border-2 border-[#EDF6FB] rounded-[10px] p-[17px] duration-200 hover:border-[#00BBC0] mb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative lg:w-[264px] w-full xl:h-[173px] h-[200px] rounded xl:mr-[43px] lg:mr-7 lg:mb-0 mb-5 flex-shrink-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: data.resim,
                        layout: "fill",
                        sizes: " (max-width: 640) 70vw, (max-width: 1024) 100vw, 260px",
                        loader: LoaderRemote/* default */.Z,
                        objectFit: "cover",
                        alt: data.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-1 right-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fancybox, {
                            options: {
                                infinite: false
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "text-white px-[17px] mb-2 xl:mb-0 xl:mr-1 mr-0 xl:w-auto w-full  py-[10px]  duration-200 bg-black/50 focus:outline-none  font-medium rounded-lg text-sm  text-center",
                                "data-fancybox": "galleryM",
                                "data-src": "https://cdn.villavillam.co.uk" + "/uploads/" + PhotosWithoutCover[0].Filename,
                                "data-thumb": "https://cdn.villavillam.co.uk" + "/uploads/150/" + PhotosWithoutCover[0].Filename,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaRegImages/* FaRegImages */.k, {
                                    size: 24
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col ml-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-white text-sm font-semibold",
                                            children: data.kisi
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-white/80 text-xs",
                                            children: person
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col ml-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-white text-sm font-semibold",
                                            children: data.yatak_odasi
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-white/80 text-xs",
                                            children: bedRoom
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col ml-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-white text-sm font-semibold",
                                            children: data.banyo
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-white/80 text-xs",
                                            children: bathRoom
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex xl:flex-row flex-col justify-between xl:mb-1 mb-5 xl:order-1 order-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center xl:justify-start justify-between xl:mb-0 mb-1 flex-col sm:flex-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center sm:mr-9",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "font-semibold text-13 leading-[18px] text-dark ",
                                                children: [
                                                    reservationNo,
                                                    " :"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold text-13 leading-[18px] text-dark border-b",
                                                children: data.id
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "font-semibold text-13 text-[#A1B2B8] leading-[18px]",
                                        children: [
                                            reservationDate,
                                            " :",
                                            data.islem_tarihi
                                        ]
                                    })
                                ]
                            }),
                            (ref = ReservationStatus[data.Durum]) === null || ref === void 0 ? void 0 : ref.actionBtnTop
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center xl:justify-start justify-between xl:mb-10 mb-1 xl:order-2 order-1 flex-col sm:flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[23px] font-semibold text-dark leading-[31px] mr-3",
                                children: data.baslik
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center space-x-3",
                                children: (ref1 = ReservationStatus[data.Durum]) === null || ref1 === void 0 ? void 0 : ref1.statusBtn
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-end justify-between order-3 xl:flex-nowrap flex-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex lg:mb-0 mb-2 lg:w-auto w-full flex-col text-center sm:flex-row sm:text-left",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col md:mr-20 sm:mr-9 flex-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mb-2",
                                                children: reservationCustomerName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark mb-2",
                                                children: data.musteri
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col md:mr-20 sm:mr-9 flex-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mb-2",
                                                children: reservationDate1
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark mb-2",
                                                children: data.tarih
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col md:mr-20 sm:mr-9 flex-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mb-2",
                                                children: reservationDate2
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark mb-2",
                                                children: data.tarih2
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col md:mr-20 sm:mr-9 flex-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mb-2",
                                                children: reservationtionPrice
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark mb-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                                    value: data.tutar,
                                                    Symbol: data.Symbol
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col",
                                children: (ref2 = ReservationStatus[data.Durum]) === null || ref2 === void 0 ? void 0 : ref2.actionBtn
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_GuestModals, {
                        guestModal: guestModal,
                        data: auth,
                        setguestLoading: setguestLoading,
                        setGuestModal: setGuestModal,
                        setOpen: setOpen,
                        open: open,
                        rez: data,
                        list: list
                    })
                ]
            }),
            (data === null || data === void 0 ? void 0 : data.yasakli) == "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: data === null || data === void 0 ? void 0 : data.icerik
                    },
                    className: "text-sm text-[#4A5568] leading-6 prose prose-sm max-w-none prose-headings:text-dark prose-headings:font-semibold prose-p:my-2 prose-ul:my-2 prose-li:my-1 prose-strong:text-dark prose-strong:font-semibold prose-a:text-[#00BBC0] prose-a:no-underline hover:prose-a:underline"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden",
                children: PhotosWithoutCover === null || PhotosWithoutCover === void 0 ? void 0 : PhotosWithoutCover.map(function(item, key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fancybox, {
                        options: {
                            infinite: false
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full h-full relative",
                            "data-fancybox": "galleryM",
                            "data-src": "https://cdn.villavillam.co.uk" + "/uploads/" + item.Filename,
                            "data-thumb": "https://cdn.villavillam.co.uk" + "/uploads/150/" + item.Filename
                        })
                    }, key);
                })
            })
        ]
    });
};
/* harmony default export */ var Reservations_ReservationItem = (ReservationItem);

// EXTERNAL MODULE: ./components/BackButton.js
var BackButton = __webpack_require__(70454);
;// CONCATENATED MODULE: ./components/Pages/Reservations/TopBar.js






var TopBar = function(param) {
    var checkLogin = param.checkLogin, setLoading = param.setLoading, isAppWebView = param.isAppWebView, customerName = param.customerName;
    var ref = (0,TranslationContext/* useTranslation */.m)(), reservations = ref.reservations, welcome = ref.welcome, logout = ref.logout, accountDelete = ref.accountDelete;
    var handleClick = function() {
        setLoading(true);
        (0,api/* AuthLogout */.VX)().then(function(data) {
            if (data.data.success) {
                checkLogin();
            }
        }).catch(function(e) {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between items-start mb-8 gap-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                        isAppWebView: isAppWebView,
                        top: "top-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold text-[14px] leading-[19px] text-[#0176AB] mt-4",
                        children: reservations.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "font-bold text-[#333738] text-[30px] leading-10",
                        children: [
                            welcome,
                            " ",
                            customerName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://members.villavillam.com.tr/",
                        target: "_blank",
                        rel: "noreferrer",
                        className: "text-xs font-semibold text-red-500 hover:underline mt-1 sm:hidden",
                        children: accountDelete
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-4 shrink-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://members.villavillam.com.tr/",
                        target: "_blank",
                        rel: "noreferrer",
                        className: "hidden sm:block text-xs font-semibold text-red-500 hover:underline",
                        children: accountDelete
                    }),
                    !isAppWebView && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        onClick: handleClick,
                        className: "btn flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative w-9 h-9",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/shutdown.png",
                                    layout: "fill",
                                    alt: "",
                                    objectFit: "contain"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-3 text-13 font-semibold",
                                children: logout
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Reservations_TopBar = (TopBar);

;// CONCATENATED MODULE: ./components/Pages/Reservations/MyReservations.js







var MyReservations = function(param) {
    var ssr = param.ssr, data = param.data, checkLogin = param.checkLogin, setLoading = param.setLoading, isAppWebView = param.isAppWebView;
    var ref;
    var ref1 = (0,TranslationContext/* useTranslation */.m)(), reservationsTab1 = ref1.reservationsTab1, reservationsTab2 = ref1.reservationsTab2, reservationsTab1Error = ref1.reservationsTab1Error, reservationsTab2Error = ref1.reservationsTab2Error;
    var ref2 = (0,react.useState)(false), reservations = ref2[0], setReservations = ref2[1];
    var ref3 = (0,react.useState)(false), filtered = ref3[0], setFiltered = ref3[1];
    var ref4 = (0,react.useState)(0), passReservations = ref4[0], setPassReservations = ref4[1];
    var ref5 = (0,react.useState)(0), activaTab = ref5[0], setActiveTab = ref5[1];
    console.log({
        reservations: reservations
    });
    (0,react.useEffect)(function() {
        List();
    }, []);
    var List = function() {
        (0,api/* GetReservations */.T4)(data.IsLogin.Token).then(function(result) {
            setReservations(result.data.data);
            setPassReservations(result.data.data.filter(function(x) {
                return x.IsPass == 1;
            }).length);
        }).catch();
    };
    //d25186573aea4deb3a049dfbfc431ddd
    (0,react.useEffect)(function() {
        setFiltered(reservations ? reservations.filter(function(x) {
            return x.IsPass == activaTab;
        }) : false);
    }, [
        activaTab,
        reservations
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-[#EDF6FB] py-8 lg:h-[calc(100vh-96px)] mb-16",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container flex flex-col h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_TopBar, {
                        setLoading: setLoading,
                        checkLogin: checkLogin,
                        isAppWebView: isAppWebView,
                        customerName: reservations === null || reservations === void 0 ? void 0 : (ref = reservations[0]) === null || ref === void 0 ? void 0 : ref.musteri
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white md:py-[38px] py-[20px] md:px-[48px] px-[20px] rounded-[30px] lg:overflow-y-auto flex-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mb-[38px] flex-col sm:flex-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "font-semibold md:text-[17px] text-[14px] text-dark leading-6 sm:mr-8 cursor-pointer ".concat(activaTab != 0 ? "opacity-50" : "", " "),
                                        onClick: function() {
                                            return setActiveTab(0);
                                        },
                                        children: [
                                            reservationsTab1,
                                            " (",
                                            reservations ? reservations.length - passReservations : 0,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "font-semibold md:text-[17px] text-[14px] text-dark leading-6 cursor-pointer ".concat(activaTab != 1 ? "opacity-50" : "", " "),
                                        onClick: function() {
                                            return setActiveTab(1);
                                        },
                                        children: [
                                            reservationsTab2,
                                            " (",
                                            passReservations,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    filtered && filtered.map(function(res, key) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_ReservationItem, {
                                            data: res,
                                            datax: data,
                                            ssr: ssr,
                                            auth: data.IsLogin,
                                            list: List
                                        }, key);
                                    }),
                                    filtered && filtered.length == 0 && activaTab == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: reservationsTab1Error
                                    }),
                                    filtered && filtered.length == 0 && activaTab == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: reservationsTab2Error
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Reservations_MyReservations = (MyReservations);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/Pages/Reservations.js










var Reservations_Reservations = function(param) {
    var ssr = param.ssr, isAppWebView = param.isAppWebView;
    var router = (0,next_router.useRouter)();
    var ref = (0,Reservations/* default */.Z)(), data = ref.data, loading = ref.loading, checkLogin = ref.checkLogin, setLoading = ref.setLoading;
    var loginSuccess = (0,TranslationContext/* useTranslation */.m)().loginSuccess;
    (0,react.useEffect)(function() {
        if (router.query.authKey || router.query.token) {
            (0,api/* AuthLogin */.rE)(null, null, router.query.authKey, router.query.token).then(function(response) {
                if (response.data.error) {
                    localStorage.removeItem("reservations_auth");
                    react_toastify_esm/* toast.error */.Am.error(response.data.error);
                } else {
                    localStorage.setItem("reservations_auth", response.data.token);
                    react_toastify_esm/* toast.success */.Am.success(loginSuccess);
                    checkLogin();
                }
            }).catch(function(error) {
                react_toastify_esm/* toast.error */.Am.error(error.message);
            });
        } else {
            checkLogin();
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-[#EDF6FB] lg:h-[calc(100vh-96px)]",
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservationsLoading/* default */.Z, {
            className: "min-h-[calc(100vh-96px)]"
        }) : data && data.IsLogin != false ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_MyReservations, {
            data: data,
            ssr: ssr,
            checkLogin: checkLogin,
            setLoading: setLoading,
            isAppWebView: isAppWebView
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Reservations_Login, {
            checkLogin: checkLogin,
            ssr: ssr
        })
    });
};
/* harmony default export */ var Pages_Reservations = (Reservations_Reservations);


/***/ }),

/***/ 23515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86408);
/* harmony import */ var react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82175);
/* harmony import */ var _styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35928);
/* harmony import */ var _styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_phone_input_2_lang_tr_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95509);









var PhoneInputW = function(_param) {
    var label = _param.label, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "label"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_4__/* .useField */ .U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    var setError = helpers.setError, setValue = helpers.setValue, setTouched = helpers.setTouched;
    var ref1 = (0,formik__WEBPACK_IMPORTED_MODULE_4__/* .useFormikContext */ .u6)(), values = ref1.values, submitForm = ref1.submitForm, submitCount = ref1.submitCount, setFieldValue = ref1.setFieldValue;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "Turkey",
        dialCode: "90",
        countryCode: "tr",
        format: "+.. ... ... .. .."
    }), country = ref2[0], setCountry = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isError = ref3[0], setIsError = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (country) {
            var pattern = new RegExp("^\\d{".concat(country.format.replaceAll(" ", "").replace("+", "").length, "}$"));
            if (!meta.touched) setTouched(true);
            if (props.isrequired == "required") {
                if (country.countryCode == "tr") {
                    setIsError(pattern.test(field.value) == false);
                    setFieldValue(props.validname, !(pattern.test(field.value) == false));
                } else {
                    setIsError(false);
                    setFieldValue(props.validname, true);
                }
            //setFieldValue(props.validname, true);
            } else {
                if (field.value.length <= country.dialCode.length) {
                    setTouched(false);
                    setFieldValue(props.validname, true);
                    setError(false);
                } else {
                    //setIsError(pattern.test(val) == false);
                    if (!meta.touched) setTouched(true);
                    //setFieldValue(
                    //  props.validname,
                    //  pattern.test(val) == true ? true : null
                    //);
                    setFieldValue(props.validname, true);
                }
            }
        }
    }, [
        field.value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative text-brand-gray-9 bg-white rounded-md shadow-[0_22px_24px_0_rgba(226,236,240,0.13)] flex items-center ".concat(props.mode == "simple" ? "h-full border px-6" : "h-[70px]  px-9", "  ").concat(!meta.error && meta.touched && !isError ? "".concat(props.mode == "simple" ? "border" : "border-2", "  border-green-400") : null, " ").concat(meta.error && meta.touched || isError && field.value.length > country.dialCode.length || submitCount > 0 && !field.value ? "".concat(props.mode == "simple" ? "border" : "border-2", " border-red-400") : null),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "font-semibold text-sm",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "h-full w-0.25 ml-5 mr-6 flex-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_2___default()), {
                        className: (_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default().PhoneInput),
                        localization: react_phone_input_2_lang_tr_json__WEBPACK_IMPORTED_MODULE_5__,
                        country: "tr",
                        inputClass: (_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default().input),
                        buttonClass: (_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default().dropDown),
                        preferredCountries: [
                            "tr"
                        ],
                        enableLongNumbers: true,
                        onChange: function(value, country, e, formattedValue) {
                            setValue(value);
                            setCountry(country);
                        },
                        value: field.value
                    }),
                    props.isrequired && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: " absolute right-4 top-4",
                        children: "*"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhoneInputW);


/***/ }),

/***/ 17601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


var InfoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 49562).then(__webpack_require__.bind(__webpack_require__, 49562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49562)
            ];
        }
    }
});
var InstagramIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 81147).then(__webpack_require__.bind(__webpack_require__, 81147));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81147)
            ];
        }
    }
});
var LogoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 60563).then(__webpack_require__.bind(__webpack_require__, 60563));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60563)
            ];
        }
    }
});
var FacebookIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55849).then(__webpack_require__.bind(__webpack_require__, 55849));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55849)
            ];
        }
    }
});
var YoutubeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 86759).then(__webpack_require__.bind(__webpack_require__, 86759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86759)
            ];
        }
    }
});
var DatepickerArrowsIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 10945).then(__webpack_require__.bind(__webpack_require__, 10945));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10945)
            ];
        }
    }
});
var LocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34364).then(__webpack_require__.bind(__webpack_require__, 34364));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34364)
            ];
        }
    }
});
var SearchIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 39750).then(__webpack_require__.bind(__webpack_require__, 39750));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39750)
            ];
        }
    }
});
var ArrowDownIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5915).then(__webpack_require__.bind(__webpack_require__, 5915));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5915)
            ];
        }
    }
});
var TimesIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 36539).then(__webpack_require__.bind(__webpack_require__, 36539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36539)
            ];
        }
    }
});
var PaymentOptionIcon1 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 57905).then(__webpack_require__.bind(__webpack_require__, 57905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57905)
            ];
        }
    }
});
var PaymentOptionIcon2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18686).then(__webpack_require__.bind(__webpack_require__, 18686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18686)
            ];
        }
    }
});
var HeartIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14119).then(__webpack_require__.bind(__webpack_require__, 14119));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14119)
            ];
        }
    }
});
var AttentionIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55613).then(__webpack_require__.bind(__webpack_require__, 55613));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55613)
            ];
        }
    }
});
var FaturaIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52415).then(__webpack_require__.bind(__webpack_require__, 52415));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52415)
            ];
        }
    }
});
var CallIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 26006).then(__webpack_require__.bind(__webpack_require__, 26006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26006)
            ];
        }
    }
});
var WhatsappnewIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 40305).then(__webpack_require__.bind(__webpack_require__, 40305));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40305)
            ];
        }
    }
});
var ReverseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 72142).then(__webpack_require__.bind(__webpack_require__, 72142));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72142)
            ];
        }
    }
});
var MapIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 88450).then(__webpack_require__.bind(__webpack_require__, 88450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88450)
            ];
        }
    }
});
var Icons_new = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 793).then(__webpack_require__.bind(__webpack_require__, 793));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(793)
            ];
        }
    }
});
var Icons_new2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14973).then(__webpack_require__.bind(__webpack_require__, 14973));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14973)
            ];
        }
    }
});
var Icons_new3 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 38796).then(__webpack_require__.bind(__webpack_require__, 38796));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38796)
            ];
        }
    }
});
var Icons_new4 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68344).then(__webpack_require__.bind(__webpack_require__, 68344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68344)
            ];
        }
    }
});
var WorkingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 73477).then(__webpack_require__.bind(__webpack_require__, 73477));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73477)
            ];
        }
    }
});
var ProblemreportIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 44059).then(__webpack_require__.bind(__webpack_require__, 44059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44059)
            ];
        }
    }
});
var WheltimeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 63270).then(__webpack_require__.bind(__webpack_require__, 63270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63270)
            ];
        }
    }
});
var GancelIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 51623).then(__webpack_require__.bind(__webpack_require__, 51623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51623)
            ];
        }
    }
});
var GuestconfirmationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 21443).then(__webpack_require__.bind(__webpack_require__, 21443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21443)
            ];
        }
    }
});
var CloseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25194).then(__webpack_require__.bind(__webpack_require__, 25194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25194)
            ];
        }
    }
});
var VillaLocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34920).then(__webpack_require__.bind(__webpack_require__, 34920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34920)
            ];
        }
    }
});
var PlayButtonIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17686).then(__webpack_require__.bind(__webpack_require__, 17686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17686)
            ];
        }
    }
});
var DetailIncludedPriceIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 59715).then(__webpack_require__.bind(__webpack_require__, 59715));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59715)
            ];
        }
    }
});
var BarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19272).then(__webpack_require__.bind(__webpack_require__, 19272));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19272)
            ];
        }
    }
});
var CallCenterIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18238).then(__webpack_require__.bind(__webpack_require__, 18238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18238)
            ];
        }
    }
});
var UserIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 78822).then(__webpack_require__.bind(__webpack_require__, 78822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78822)
            ];
        }
    }
});
var ClockIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 76255).then(__webpack_require__.bind(__webpack_require__, 76255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76255)
            ];
        }
    }
});
var PaginationPrevIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17151).then(__webpack_require__.bind(__webpack_require__, 17151));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17151)
            ];
        }
    }
});
var PaginationNextIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18229).then(__webpack_require__.bind(__webpack_require__, 18229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18229)
            ];
        }
    }
});
var ShareIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 91788).then(__webpack_require__.bind(__webpack_require__, 91788));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91788)
            ];
        }
    }
});
var HousekeepingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 29097).then(__webpack_require__.bind(__webpack_require__, 29097));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29097)
            ];
        }
    }
});
var CameraIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 22437).then(__webpack_require__.bind(__webpack_require__, 22437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22437)
            ];
        }
    }
});
var TeamIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 42908).then(__webpack_require__.bind(__webpack_require__, 42908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42908)
            ];
        }
    }
});
var CommentIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 97088).then(__webpack_require__.bind(__webpack_require__, 97088));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97088)
            ];
        }
    }
});
var WalletIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18688).then(__webpack_require__.bind(__webpack_require__, 18688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18688)
            ];
        }
    }
});
var UserodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18024).then(__webpack_require__.bind(__webpack_require__, 18024));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18024)
            ];
        }
    }
});
var MailodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 37822).then(__webpack_require__.bind(__webpack_require__, 37822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37822)
            ];
        }
    }
});
var PhoneodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 28892).then(__webpack_require__.bind(__webpack_require__, 28892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28892)
            ];
        }
    }
});
var EditodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 35623).then(__webpack_require__.bind(__webpack_require__, 35623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35623)
            ];
        }
    }
});
var LockodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9748).then(__webpack_require__.bind(__webpack_require__, 9748));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9748)
            ];
        }
    }
});
var LocationPinIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 80707).then(__webpack_require__.bind(__webpack_require__, 80707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80707)
            ];
        }
    }
});
var StarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 99484).then(__webpack_require__.bind(__webpack_require__, 99484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99484)
            ];
        }
    }
});
var KtbIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9842).then(__webpack_require__.bind(__webpack_require__, 9842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9842)
            ];
        }
    }
});
var Icon = function(param) {
    var name = param.name, _size = param.size, size = _size === void 0 ? 24 : _size, className = param.className;
    var icons = {
        info: InfoIcon,
        logo: LogoIcon,
        instagram: InstagramIcon,
        facebook: FacebookIcon,
        youtube: YoutubeIcon,
        datepickerArrows: DatepickerArrowsIcon,
        location: LocationIcon,
        search: SearchIcon,
        ArrowDown: ArrowDownIcon,
        Times: TimesIcon,
        PaymentOption1: PaymentOptionIcon1,
        PaymentOption2: PaymentOptionIcon2,
        Heart: HeartIcon,
        attention: AttentionIcon,
        fatura: FaturaIcon,
        call: CallIcon,
        whatsappnew: WhatsappnewIcon,
        reverse: ReverseIcon,
        map: MapIcon,
        newIcon1: Icons_new,
        newIcon2: Icons_new2,
        newIcon3: Icons_new3,
        newIcon4: Icons_new4,
        working: WorkingIcon,
        villaLocation: VillaLocationIcon,
        PlayButton: PlayButtonIcon,
        DetailIncludedPrice: DetailIncludedPriceIcon,
        Bar: BarIcon,
        CallCenter: CallCenterIcon,
        problemreport: ProblemreportIcon,
        wheltime: WheltimeIcon,
        gancel: GancelIcon,
        guestconfirmation: GuestconfirmationIcon,
        close: CloseIcon,
        user: UserIcon,
        clock: ClockIcon,
        PaginationPrev: PaginationPrevIcon,
        PaginationNext: PaginationNextIcon,
        Share: ShareIcon,
        Wallet: WalletIcon,
        Comment: CommentIcon,
        Camera: CameraIcon,
        Housekeeping: HousekeepingIcon,
        Team: TeamIcon,
        userodeme: UserodemeIcon,
        mailodeme: MailodemeIcon,
        phoneodeme: PhoneodemeIcon,
        editodeme: EditodemeIcon,
        lockodeme: LockodemeIcon,
        LocationPin: LocationPinIcon,
        Star: StarIcon,
        ktb: KtbIcon
    };
    var Component = icons[name];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        size: size,
        className: className
    });
};



/***/ }),

/***/ 88041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ReservationLoginShema; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);
/* harmony import */ var yup_locales__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18700);


if (false) {} // en: Yup varsayilan (Ingilizce) mesajlari
var ReservationLoginShema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required().email(),
    reservationNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().required()
});


/***/ }),

/***/ 98747:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"leftSpace":"Login_leftSpace__5zya4"};

/***/ }),

/***/ 35928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PhoneInput":"PhoneInput_PhoneInput__q7Kkj","PhoneInputCountry":"PhoneInput_PhoneInputCountry__i4tLe","dropDown":"PhoneInput_dropDown__K8cbG","input":"PhoneInput_input__zsoED"};

/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

}]);